module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/sg/sg_c_positivo-4b9b58c6ce5b63fb2e52cae2f4e54874.svg";